import { Routes } from 'consts'
import React from 'react'
import { Navigate, useLocation } from 'react-router'

export function Redirect() {
  const { search } = useLocation()
  return <Navigate to={Routes.SelectFlow + search} />
}
